<template>
  <div class="navFooter-page">
    <div class="navFooter-header">
      <div style="display: flex;justify-content: space-between;align-items: center;width: 1200px;margin: 1px auto 0;">
        <div style="width: 499px;height: 64px;">
          <el-image style="width: 499px;height: 64px" :src="require('@@/assets/logo3.png')"></el-image>
        </div>
        <div >
          <div style="color: #fff;font-size: 20px;display: flex;justify-content: left;align-items: center;margin-bottom: 14px">
            <div style="margin-right: 12px">联系电话:</div>
            <div style="">0311-82451129</div>
          </div>
          <div style="display: flex;justify-content: left;align-items: center">
            <div style="color: #fff;font-size: 16px;display: flex;justify-content: left;align-items: center;margin-right: 55px">
              <el-image style="width: 20px;height: 20px" :src="require('@@/assets/images/bottom/dz.png')"></el-image>
              <div style="margin-right: 12px">地址:</div>
              <div>石家庄市综合商务中心南区11楼</div>
            </div>
            <div style="color: #fff;font-size: 16px;display: flex;justify-content: left;align-items: center">
              <el-image style="width: 20px;height: 20px" :src="require('@@/assets/images/bottom/yx.png')"></el-image>
              <div style="margin-right: 12px">邮编:</div>
              <div>050000</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="navFooter-content">
      <span style="margin-right: 50px">
        <el-link href="https://beian.miit.gov.cn/" target="_blank" > 冀ICP备2025107605号 </el-link>
      </span>
      <div>河北自贸区正定片区产业发展集团有限责任公司 网站版权注册 1996 - 2022 INSPUR Co., Ltd.</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {

  },
  data() {
    return {
      pageList:{
        navigationData:[
          {label:'网站首页'},  {label:'集团介绍'},  {label:'文明创建'}, {label:'新闻中心'}, {label:'政务公开'},
          {label:'党建建设'}, {label:'纪检监察'},  {label:'企业文化'},  {label:'联系我们'}, {label:'采购专区'},
        ],

      }
    }
  },
  methods:{

  }
}
</script>
<style scoped lang="less">
.navFooter-page{
  width: 100%;
  height: 141px;
}
.navFooter-header{
  height: 101px;
  background: #151C24;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.navFooter-content{
  width: 1200px;
  margin: 0 auto;
  height: 40px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  color: #999999;
  box-sizing: border-box;
  font-size: 12px;
}
</style>
